/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import {error} from '@ion/core/src/logger/logger';
import {
  loadDevices
} from '@ion/core/src/services/Connect';
import {LoadDevicesParams} from '@ion/core/src/types/services';
import {PageInitializeAction} from '@/types/redux';
import {getAccountId} from '../helpers';

// name of reducer
export const NAME                       = 'adminDevices';

export const INITIALIZE_ADMIN_DEVICES   = 'INITIALIZE_ADMIN_DEVICES';

export const SET_GRID_COLUMNS           = 'SET_ADMIN_DEVICES_GRID_COLUMNS';
export const UPDATE_GRID_COLUMNS        = 'UPDATE_ADMIN_DEVICES_GRID_COLUMNS';

export const GET_ADMIN_DEVICES_REQUEST  = 'GET_ADMIN_DEVICES_REQUEST';
export const GET_ADMIN_DEVICES_RESPONSE = 'GET_ADMIN_DEVICES_RESPONSE';
export const GET_ADMIN_DEVICES_ERROR    = 'GET_ADMIN_DEVICES_ERROR';

/**
 * @initialize
 */
export const initializeAdminDevices = (): PageInitializeAction => {
  return {type: INITIALIZE_ADMIN_DEVICES};
};

/**
 * @getAdminDevices
 */
export const getAdminDevices = ({
  pageId = 1,
  pageSize = 20,
  sort,
  filter,
  includeSubGroups = false,
  callback: callbackFn
}) => {
  return async(dispatch: Function, getState: Function): Promise<any> => {
    dispatch({type: GET_ADMIN_DEVICES_REQUEST});
    const data: LoadDevicesParams = {
      accountId    : getAccountId(getState),
      pageId,
      pageSize,
      includeSubGroups,
      withLocation : true
    };
    if (sort) {
      data.sortOn = sort;
    }
    if (filter) {
      data.filterOn = filter;
    }
    try {
      const {devices: items, totalCount} = await loadDevices(data);
      dispatch({type: GET_ADMIN_DEVICES_RESPONSE});
      callbackFn?.({items, totalCount});
      return {items, totalCount};
    } catch (err) {
      error(err);
      dispatch({type: GET_ADMIN_DEVICES_ERROR, error: err});
      return err;
    }
  };
};
